export default __webpack_public_path__ + "static/reactnativ-86793c1a6e8522eb799c152d97c55d9e.png";